<template>
  <div class="extra-amount-options">
    <IconBoxWrapper :icon="icon">
      <div :class="getExtraAmountOptionsContentClass">
        <template v-if="double">
          <section class="extra-amount">
            <Field v-slot="{ errors, field, value }" v-model="localMin" :name="$filters.formLabelValidation(amountMinLabel)" :rules="rules">
              <QInput
                v-bind="field"
                :model-value="value"
                no-error-icon
                stack-label
                :disable="isDisabled"
                type="number"
                :step="step"
                :label="amountMinLabel"
                :suffix="suffix"
                :error="errors.length > 0"
                :error-message="errors[0]"
                @update:model-value="$emit('setMin', parseFloat($event))"
              />
            </Field>
          </section>
          <section class="extra-amount">
            <Field
              v-slot="{ errors, field, value }"
              v-model="localMax"
              :name="$filters.formLabelValidation(amountMaxLabel)"
              :rules="Object.assign({ ...rules }, { min_value: min && min > 0 ? min : 0 })"
            >
              <QInput
                v-bind="field"
                :model-value="value"
                no-error-icon
                stack-label
                :disable="isDisabled"
                type="number"
                :step="step"
                :label="amountMaxLabel"
                :suffix="suffix"
                :error="errors.length > 0"
                :error-message="errors[0]"
                @update:model-value="$emit('setMax', parseFloat($event))"
              />
            </Field>
          </section>
        </template>
        <template v-else>
          <section class="extra-amount">
            <Field v-slot="{ errors, field, value }" v-model="localAmount" :name="$filters.formLabelValidation(amountLabel)" :rules="rules">
              <QInput
                v-bind="field"
                :model-value="value"
                stack-label
                :disable="isDisabled"
                :placeholder="amountPlaceholder"
                type="number"
                :step="step"
                :label="amountLabel"
                :suffix="suffix"
                :error="errors.length > 0"
                :error-message="errors[0]"
                @update:model-value="$emit('setAmount', parseFloat($event))"
              />
            </Field>
          </section>
        </template>
        <section v-if="options" class="extra-options">
          <QSelect
            :model-value="option"
            stack-label
            emit-value
            :disable="isDisabled"
            map-options
            :label="optionsLabel"
            option-value="id"
            :options="options"
            :popup-cover="false"
            @update:model-value="$emit('setOption', $event)"
          />
        </section>
      </div>
    </IconBoxWrapper>
  </div>
</template>
<script>
  import { Field } from "vee-validate";

  export default {
    components: { Field },
    props: {
      rules: { type: Object, default: () => ({}) },
      amount: { type: Number, default: null },
      min: { type: Number, default: null },
      max: { type: Number, default: null },
      step: { type: Number, default: undefined },
      amountMinLabel: { type: String, default: "Min" },
      amountMaxLabel: { type: String, default: "Max" },
      amountLabel: { type: String, default: "Amount" },
      amountPlaceholder: { type: String, default: null },
      double: { type: Boolean, default: false },
      isDisabled: { type: Boolean, default: false },
      icon: { type: String, default: null },
      suffix: { type: String, default: null },
      option: { type: null, default: null },
      options: { type: Array, default: null },
      optionsLabel: { type: String, default: " " },
    },
    emits: ["setAmount", "setMin", "setMax", "setOption"],
    data() {
      return {
        localMin: this.min,
        localMax: this.max,
        localAmount: this.amount,
      };
    },
    computed: {
      getExtraAmountOptionsContentClass() {
        let tagClasses = "extra-amount-options-content";
        if (this.isDisabled) {
          tagClasses += " bg-primary-ultra-light";
        }
        if (this.$q.screen.lt.sm) {
          tagClasses += " extra-amount-options-content-mobile";
        }
        return tagClasses;
      },
    },
    watch: {
      amount(value) {
        this.localAmount = value;
      },
      min(value) {
        this.localMin = value;
      },
      max(value) {
        this.localMax = value;
      },
    },
  };
</script>

<style lang="scss">
  .extra-amount-options {
    .extra-amount-options-content {
      display: flex;
      .q-field--with-bottom {
        padding-bottom: 0;
        &.q-field--error {
          padding-bottom: 20px;
        }
      }
      &.extra-amount-options-content-mobile {
        flex-direction: column;
        .extra-options {
          width: auto;
          flex: 1;
        }
      }
      > section {
        padding: 0 10px 8px;

        &.extra-amount {
          flex: 1;
        }

        &.extra-options {
          border-left: 1px solid #eff1f4;
          width: 140px;
        }
      }
    }
  }
</style>
